// The details the Terms and Privacy pages quote. Fill the bracketed ones in before the pages go live.
export const COMPANY = "Minnedev, LLC"
export const SITE_NAME = "Disc Golf Manager"
export const SITE_URL = "https://discgolfmanager.com"
export const CONTACT_EMAIL = "support@discgolfmanager.com"
export const GOVERNING_STATE = "Minnesota"
// When the current text took effect; update it whenever the terms or policy change
export const EFFECTIVE_DATE = "10/01/2026"
